import { Component, OnInit, Input } from '@angular/core';
import { DwModalRef } from 'ng-quicksilver';
import { FxDapHttpClient } from '../../fx-http-client';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { JsonpModule } from '@angular/http';

@Component({
  selector: 'edit-comcond',
  template: 
  `
  
  <div class="fx_modal_container edit-comcond_modal" appModalDrag>
    <form dw-form class="fx_modal_form">
      <div dw-row class="dw-f-table dw-f-row-bottom-margin" style="min-height: 300px;">
        <div dw-col [dwSpan]="14">
          <dw-table class="edit-comcond_table" #dwTable dwBordered [dwData]="dataList" [dwShowPagination]="false" [dwFrontPagination]="false" [dwScroll]="{ y: '240px' }" dwSize="middle" >
            <thead dw-thead>
              <tr style="font-size: 14px;">
                <th dw-th style="width: 50%;background-color:#EFF3FF;height:44px;text-align: center;">
                  <span translate>com-常用条件名称</span>
                </th>
                <th dw-th style="width: 30%;background-color:#EFF3FF;text-align: center;">
                  <span translate>com-默认查询条件</span>
                </th>
                <th dw-th style="width: 20%;background-color:#EFF3FF;text-align: center;">
                  <span translate>com-操作</span>
                </th>
              </tr>
            </thead>
            <tbody dw-tbody cdkDropList (cdkDropListDropped)="drop($event)"
             *ngFor="let data of dataList; let idx = index" [ngClass]="{active: data.isSelected}" (click)="selectItem(idx)">
              <tr dw-tbody-tr  cdkDrag>
                <td dw-td style="width: 50%;">
                  <div style="display:flex;">
                    <a>
                      <div style="width: 25px;height: 30px;position: absolute;z-index: 2;cursor:move;"></div>
                      <!-- <img style="width: 25px;height: 25px;z-index:1;" src="assets/img/home/拖动.png"> -->
                    </a>
                  <input dw-input [(ngModel)]="data.label" name="label{{idx}}" >
                  </div>
                </td>
                <td dw-td style="width: 30%;text-align: center;">
                  <label dw-checkbox [(ngModel)]="data.aan005c" name="check{{idx}}"  (ngModelChange)="changeChecked(idx)">
                  </label>
                </td>
                <td dw-td style="width: 20%;;text-align: center;">
                  <span class="dw-link-txt">
                  <a translate (click)="delComCond(idx)" >删除</a>
                  </span>
                </td>
              </tr>
            </tbody>
          </dw-table>
        </div>
        <div dw-col [dwSpan]="10">
          <dw-table class="edit-comcond_table" #dwTable dwBordered [dwData]="dataList" [dwShowPagination]="false" [dwFrontPagination]="false" [dwScroll]="{ y: '240px' }" dwSize="middle" >
            <thead dw-thead>
              <tr style="font-size: 14px;">
                <th dw-th style="width: 100%;background-color:#EFF3FF;height:44px">
                  <span translate>{{title}}</span>
                </th>
              </tr>
            </thead>
            <tbody dw-tbody>
              <tr>
                <td dw-td  class="td-row" style="width: 100%;">
                  <button class="edit-comcond_btn" dw-button [dwGhost]="item.selected ? true : false" [dwType]="item.selected ? 'primary' : 'default'" *ngFor="let item of btnList; let inIdx = index" (click)="selBtnItem(item)">{{item.name}}</button>
                </td>
              </tr>
            </tbody>
          </dw-table>
        </div>
      </div>
      <div class="customize-footer">
        <button dw-button type="button" [dwType]="'default'" (click)="handleCancel()">{{ 'dw-cancel' | translate}}</button>
        <button dw-button [dwType]="'primary'" (click)="handleOk()">{{ 'dw-save' | translate}}</button>
      </div>
    </form>
  </div>
  
  `,
  styles: [
    `
    :host ::ng-deep .customize-footer {
      padding: 0;
      text-align: right;
      border-radius: 0 0 0px 0px;
      margin: 0;
    }
    .edit-comcond_modal .active {
      background: #eee !important;
    }
    :host ::ng-deep .ant-layout-content {
      margin: -24px;
    }
    :host ::ng-deep .fx_modal_form {
      padding: 10px;
    }
    :host ::ng-deep .fx_modal_form tr th {
      padding: 0px 10px !important;
      height: 28px;
      font-size: 12px;
    }
    :host ::ng-deep .ant-table-placeholder {
      border-bottom: none;
      font-size: 12px;
    }
    :host ::ng-deep .customize-footer button {
      padding: 0 15px;
      transition: 1s all;
      -webkit-transition: 1s all;
      background: #69c0ff;
      border-color: #69c0ff;
      color: #fff;
      box-shadow: 0 1px 6px #bae7ff;
    }
    :host ::ng-deep .customize-footer button:last-child {
      color: #fff;
      border-color: #1890ff;
      background: #1890ff;
      box-shadow: 0px 1px 6px 0px #72c0ff;
    }
    .customize-footer button:hover {
      border-color: #3aa7ff;
      background: #3aa7ff;
    }
    :host ::ng-deep .customize-footer button:last-child:hover {
      color: #fff;
      border-color: #0b79de;
      background: #0b79de; 
    }     

    .edit-comcond_btn {
      margin: 0 10px 10px 0;
      padding: 7px 16px;
      line-height: 14px;
    }

    .edit-comcond_modal th,
    .edit-comcond_modal td {
      // border: none
    }

    .edit-comcond_modal tbody{
      // border-bottom: 1px solid #ccc;
    }

    .edit-comcond_modal .ant-table-thead > tr.ant-table-row-hover > td, 
    .edit-comcond_modal .ant-table-tbody > tr.ant-table-row-hover > td, 
    .edit-comcond_modal .ant-table-thead > tr:hover > td, 
    .edit-comcond_modal .ant-table-tbody > tr:hover > td {
      background: transparent;
    }

    .edit-comcond_modal .td-row {
      border-bottom: 1px solid #ccc;
    }

    table, th, td {
      border: inherit;
    }

    .edit-comcond_modal .ant-table-header > table {
      border-top: 0;
    }
    .edit-comcond_modal  .ant-btn-default:focus {
      color: rgba(0, 0, 0, 0.65);
      background-color: #fff;
      border-color: #d9d9d9;
    }
    `
  ]
})
export class editCondComponent implements OnInit  {
  @Input() programId: string = '';// 作业编号
  public editForm: FormGroup;
  @Input() dataList: any;
  public btnList: Array<any> = [];// 记录当前选中的按钮
  public title = '按钮';
  public selectedIdx = -1;

  constructor(
    private modalSubject: DwModalRef,
    public http: FxDapHttpClient
  ) {}

  ngOnInit(): void {
    
    this.dataList.forEach(s => {
      s.btnList = [];
    })
    this.getAuthedButtonList();
  }
//修改默认值
  changeChecked(xIdx): void{
    if (this.dataList[xIdx].aan005c) {
      for (let index = 0; index < this.dataList.length; index++) {
        if (xIdx != index) {
          this.dataList[index].aan005c = false;
        }
      }
    }
  }
//删除
  delComCond(xIdx): void{    
    this.dataList[this.selectedIdx].btnList = JSON.parse(JSON.stringify(this.btnList || []));
    this.dataList.splice(xIdx, 1);
    if (xIdx <= this.selectedIdx) { 
        if (this.dataList.length) {
          this.selectedIdx = -1;
          this.selectItem(0);
        }
    }
  }

  selectItem(xIdx): void {
    if (this.selectedIdx !== -1) {
      this.dataList[this.selectedIdx].btnList = JSON.parse(JSON.stringify(this.btnList || []));
    }
    for (let index = 0; index < this.dataList.length; index++) {
      if (xIdx != index) {
        this.dataList[index].isSelected = false;
      } else {
        this.dataList[index].isSelected = true;
        this.title = (this.dataList[index].label || '') + '按钮';
        this.btnList = JSON.parse(JSON.stringify(this.dataList[index].btnList || []));
        this.selectedIdx = index;
      }
    }
  }
  //上移
  sortUp(): void{
    var nowIndex= this.dataList.findIndex(function(obj) {
      return obj.isSelected == true;
    });
    if ((nowIndex == 0) || nowIndex == -1) { return;}
    var oldData = Object.assign({}, this.dataList[nowIndex -1]);
    this.dataList[nowIndex -1] = Object.assign({}, this.dataList[nowIndex]);
    this.dataList[nowIndex] = Object.assign({}, oldData);
  }
  //下移
  sortDown(): void{
    var nowIndex= this.dataList.findIndex(function(obj) {
      return obj.isSelected == true;
    });
    if ((nowIndex == (this.dataList.length-1)) || nowIndex == -1) { return;}
    var oldData = Object.assign({}, this.dataList[nowIndex +1]);
    this.dataList[nowIndex +1] = Object.assign({}, this.dataList[nowIndex]);
    this.dataList[nowIndex] = Object.assign({}, oldData);
  }

  handleOk(): void {
    this.dataList.forEach((s, idx) => {
      if (s.isSelected == true) {
        s.btnList = JSON.parse(JSON.stringify(this.btnList || []));
      }
      if (s.btnList && s.btnList.length) {             
        s.btnList.forEach(t => {
          t.adk004 = t.id; // 按钮编号
          t.adk005 = t.aaj003; // 按钮分组
        })
      }
    })
    this.modalSubject.triggerOk();
  }

  handleCancel(): void {
    this.modalSubject.triggerCancel();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.dataList, event.previousIndex, event.currentIndex);
  }

  // 获取有权限按钮清单
  getAuthedButtonList() {
    this.http.post('A/IACommonService/showButtonDisplay', { param: { program_no: this.programId } }, { headers: { 'program-code': this.programId } }).subscribe(response => {
      if (response.success && response.data && response.data.length) {
        this.dataList.forEach(s => {
          s.btnList = JSON.parse(JSON.stringify(response.data));
          if (s.adk_f_list && s.adk_f_list.length) {
            s.btnList.forEach(t => {
              const idx = s.adk_f_list.findIndex(x => {
                return x.adk004 == t.id;
              });
              if (idx !== -1) {
                t.selected = true;
              }
            })
          }
        })
      } else { 
      }
      this.selectItem(0);
    });
  }

  // 按钮选择
  selBtnItem(item) {
    item.selected = !item.selected;
  }

}